export default __webpack_public_path__ + "static/media/fontMulish900_latin_ext.62f3e8b5.woff2";